<template>
  <div>
    <a-row type="flex" justify="space-between">
      <a-col :span="24">
        <a-row type="flex" justify="space-between" align="bottom" style="margin-bottom: 30px">
          <a-col :span="14" class="titulo">Categorías</a-col>
          <a-col><a-button type="primary" size="large" @click="newCategoryForm()">Agregar nueva
            categoría</a-button></a-col>
        </a-row>
      </a-col>
      <a-col :span="10">
        <a-form v-if="categoryFormIsOpen" layout="vertical" :form="formCategories" @submit="crearCategoria">
          <h1 class="titulo" style="font-weight: bold; font-size: 16px; margin-bottom: 20px">
            Crear Nueva Categoría:
          </h1>
          <a-form-item style="display: none;">
            <a-input v-decorator="['id']" class="shadowInputs" />
          </a-form-item>

          <a-form-item>
          <span slot="label">
            Nombre
          </span>
            <a-input v-decorator="[
            'name',
            {
              rules: [
                {
                  required: true,
                  message: 'Ingrese un nombre para esta categoría',
                },
              ],
            },
          ]" class="shadowInputs" />
          </a-form-item>

          <a-form-item>
            <a-row type="flex" justify="end" align="middle" :gutter="20">
              <a-col><a-button type="primary" html-type="submit" size="large">Guardar</a-button></a-col>
              <a-col><a-button @click="categoryFormIsOpen = false" size="large">Cancelar</a-button></a-col>
            </a-row>
          </a-form-item>
        </a-form>
      </a-col>
      <a-col :span="12" />
      <a-col :span="24"
             style=" word-break: break-all; background-color: white; padding: 20px 10px 5px; border-radius: 5px;"
             class="shadow">
        <a-row style="display: flex;  justify-content: flex-end; margin-bottom:20px">
          <a-input-search placeholder="Filtrar por Nombre" v-model="categoryNameFilter" style="width: 200px;" />
        </a-row>
        <a-row>
          <a-table :columns="columnsListTable" :dataSource="filterCategories" rowKey="id" :pagination="pagination">
          </a-table>
        </a-row>
      </a-col>

    </a-row>
  </div>

</template>

<script>
import utils from '../service/service.js'
export default {
  name: "Categories",
  // props: {},
  mixins: [utils],
  data() {
    return {
      isAdmin: "0",
      categories: [],
      columnsListTable: [
        {
          title: "Id",
          dataIndex: "id",
        },
        {
          title: "Categoría",
          dataIndex: "name",
        }
      ],
      pagination: { pageSize: 8 },
      categoryFormIsOpen: false,
      categoryNameFilter: "",
      isEdit: false,
      formCategories: this.$form.createForm(this)
    };
  },
  mounted: function () {
    this.loadCategories();
  },
  methods: {
    crearCategoria(e) {
      e.preventDefault();
      this.formCategories.validateFields(async (err) => {
        if (err !== null) { return false; }
        const data = this.formCategories.getFieldsValue();
        let url = "";
        const { code } = await this.sendRequest({
          method: 'POST',
          url: 'categories/create',
          data: data,
        })
        if (code === 200) {
          this.$message.success('Categoría creada')
          this.loadCategories();
          this.categoryFormIsOpen = false;
        }
      });
    },
    newCategoryForm() {
      this.formCategories.resetFields();
      this.categoryFormIsOpen = true;
    },
    openEditVariable(id) {
      this.isEdit = true;
      return new Promise((resolve) => {
        const usuario = this.usuarios.find((variable) => { return variable.id == id; });
        this.categoryFormIsOpen = true;
        delete usuario.nivel;
        delete usuario.stateName;
        resolve(usuario);
      }).then((data) => {
        this.formCategories.setFieldsValue(data);
      });
    },
    async loadCategories() {
      const { data } = await this.sendRequest({
        method: 'GET',
        url: 'categories/list',
      })

      this.categories = data;
    },
  },
  computed: {
    filterCategories() {
      var $this = this;
      return $this.categories.filter(function (data) {
        return (
            $this.categoryNameFilter == "" ||
            data.name.toLowerCase().includes($this.categoryNameFilter.toLowerCase())
        );
      });
    },
  },
};
</script>

<style scoped>
.titulo {
  font-size: 20px;
  font-weight: bold;
  text-align: left;
  color: #2c3e50;
}

.shadow {
  box-shadow: 2px 1px 5px -4px;
}

.shadowInputs {
  box-shadow: 1px 1px 5px -5px;
}
</style>
